/**
 * Check if an element is in viewport
 *
 * @param {number} [offset]
 * @param element [HTMLElement]
 * @returns {boolean}
 */
export function isInViewport<T extends HTMLElement>(
    element: T | null,
    offset = 0
) {
    if (!element) return false;
    const top = element.getBoundingClientRect().top;
    return top + offset >= 0 && top - offset <= window.innerHeight;
}
